import { combineReducers } from 'redux'
import * as Reducers from 'redux/modules'

const rootReducer = combineReducers({
  ...Reducers,
})

export default rootReducer
